module.exports = __webpack_public_path__ + "static/media/icon_47.aaf97fdd.svg";